import styled from '@emotion/styled';
import UIDivider from '@portalterreno/react-ui-core/Divider';
import { media } from '@portalterreno/react-ui-core/Grid';

const Divider = styled(UIDivider)({
  [media('xs')]: {
    maxWidth: '100%',
    marginTop: 18,
    marginBottom: 13
  },
  [media('lg')]: {
    maxWidth: '50%',
    marginTop: 18,
    marginBottom: 18
  }
});

export default Divider;
